// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22dlg","col":"styles_col__1pO1y"};